<template>
  <vs-tabs 
    :position="isSmallerScreen ? 'top' : 'left'" v-model="active_tab" 
    class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <!-- <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-general />
      </div>
    </vs-tab> -->
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Cambiar Contraseña' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password />
      </div>
    </vs-tab>
    <!-- <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Información' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-info />
      </div>
    </vs-tab> -->
    <vs-tab v-if="activeUserInfo.role && activeUserInfo.role == 'doctor'"
     icon-pack="feather" icon="icon-clock" :label="!isSmallerScreen ? 'Disponibilidad' : ''">
      <div class="tab-social-links md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-availability />
      </div>
    </vs-tab>
    <vs-tab v-if="activeUserInfo.role && activeUserInfo.role == 'doctor'"
      icon-pack="feather" icon="icon-link-2" :label="!isSmallerScreen ? 'Conexiones' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-connections />
      </div>
    </vs-tab>
    <vs-tab v-if="activeUserInfo.role && activeUserInfo.role == 'doctor'"
      icon-pack="feather" icon="icon-file-plus" :label="!isSmallerScreen ? 'Recetas y Exámenes' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-media />
      </div>
    </vs-tab>
    <vs-tab v-if="activeUserInfo.role && activeUserInfo.role == 'doctor'"
      icon-pack="feather" icon="icon-check-circle" :label="!isSmallerScreen ? 'Consulta' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-links />
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-dollar-sign" :label="!isSmallerScreen ? 'Caja' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-Register />
      </div>
    </vs-tab>

    <vs-tab v-if="!isSecretary" icon-pack="feather" icon="icon-credit-card" :label="!isSmallerScreen ? 'Pagos y Suscripciones' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-Payment />
      </div>
    </vs-tab>
    <vs-tab v-if="!isSecretary" icon-pack="feather" icon="icon-file-text" :label="!isSmallerScreen ? 'Factura Electrónica' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-FEL />
      </div>
    </vs-tab>
    <!-- 
    <vs-tab icon-pack="feather" icon="icon-link-2" :label="!isSmallerScreen ? 'Formularios' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-Links />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Notificaciones' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-notifications />
      </div>
    </vs-tab> -->
  </vs-tabs>
</template>

<script>
import UserSettingsGeneral from './UserSettingsGeneral.vue'
import UserSettingsChangePassword from './UserSettingsChangePassword.vue'
import UserSettingsInfo from './UserSettingsInfo.vue'
import UserSettingsAvailability from './UserSettingsAvailability.vue'
import UserSettingsConnections from './UserSettingsConnections.vue'
import UserSettingsNotifications from './UserSettingsNotifications.vue'
import UserSettingsRegister from './UserSettingsRegister.vue'
import UserSettingsLinks from './UserSettingsLinks.vue'
import UserSettingsMedia from './UserSettingsMedia.vue'
import UserSettingsPayment from './UserSettingsPayment.vue'
import UserSettingsFEL from './UserSettingsFEL.vue'



export default {
  components: {
    UserSettingsGeneral,
    UserSettingsChangePassword,
    UserSettingsInfo,
    UserSettingsAvailability,
    UserSettingsConnections,
    UserSettingsNotifications,
    UserSettingsRegister,
    UserSettingsLinks,
    UserSettingsMedia,
    UserSettingsPayment,
    UserSettingsFEL
  },
  data () {
    return {
      active_tab: 0,
      isSecretary: false,
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  beforeMount() {
    // 
    if(this.activeUserInfo.role !== "doctor" ){
      console.log('Es SECRE');
      this.isSecretary = true;
      this.$store.dispatch('getDoctorDataById', sessionStorage.getItem('activeDoctorId')).then(response=>{
        // console.log('DOCTOR: ',response);
        this.activeDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
            
      }, error => {
        console.error(error);
      });
    } else {
      this.isSecretary = false;
    }
    console.log(this.activeUserInfo)   
    // 
    // console.log(this.$route);
    if(this.$route.query.activeTab && this.$route.query.activeTab == 'connections'){
      this.active_tab = 2;
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
